export const tableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: 'SECTOR',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'NOMBRE DEL PROGRAMA (1)',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'ENSAYO / MAGNITUD G(2)',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'ÍTEM DE ENSAYO DE APTITUD (3)',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'FRECUENCIA (4)',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'MÉTODO PARA ESTABLECER EL VALOR ASIGNADO (5)',
                    type: 'custom-html',
                    key: 'level11',
                    modifier: (item) => {
                        return item;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}